<template>
  <v-container>
    <v-card outlined>
      <v-card-title>
        <v-layout>
          <v-flex xs4>
            <!-- <div class="subtitle-2 mb-1">Select Region</div> -->
            <v-select
              outlined
              dense
              hide-details
              return-object
              :items="modRegions"
              v-model="selectedRegion"
              item-text="name"
              placeholder="Select Region"
              @change="changeRegion"
            >
            </v-select>
          </v-flex>

          <v-flex text-right>
            <v-btn @click="openNewEntityDialog" depressed color="primary">
              Create New Entity
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="mx-4">
        <v-flex xs6>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="reviewedEntities"
        :items-per-page="30"
        class="elevation-0"
        :search="search"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>
        <template v-slot:item.hasProfile="{ item }">
          <v-btn
            small
            text
            v-if="item.hasProfile"
            class="text-none subtitle-2"
            @click="openEditProfileDialog(item)"
          >
            <v-icon class="mr-1" small> mdi-pencil</v-icon> Profile
          </v-btn>
          <v-btn
            class="text-none subtitle-2"
            v-else
            text
            small
            @click="openNewProfileDialog(item)"
          >
            <v-icon class="mr-1" small>mdi-plus</v-icon> Profile
          </v-btn>
        </template>
        <template v-slot:item.updatedAt="{ item }">
          <div>
            {{ iMoment(item.updatedAt) }}
          </div>
        </template>
      </v-data-table>
    </v-card>
    <new-entity-dialog ref="newEntityDialog" />
    <edit-entity-dialog :details="editedItem" ref="editEntityDialog" />
    <edit-profile-dialog ref="editProfileDialog" />
    <new-profile-dialog ref="newProfileDialog" />
    <v-dialog v-model="dialogDelete" width="300">
      <v-card>
        <v-card-title>Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            class="text-none subtitle-2"
            @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-none subtitle-2"
            text
            @click="deleteItemConfirm"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import NewEntityDialog from "../components/NewEntityDialog";
import EditEntityDialog from "../components/EditEntityDialog";
import EditProfileDialog from "../components/EditProfileDialog";
import NewProfileDialog from "../components/NewProfileDialog";
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  components: {
    NewEntityDialog,
    EditEntityDialog,
    EditProfileDialog,
    NewProfileDialog,
  },
  data() {
    return {
      search: "",
      selectedRegion: {},
      selectedEntity: {},
      dialogDelete: false,
      itemToDelete: {
        name: "",
        latitude: "",
        longitude: "",
      },
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "title",
        },
        // { text: "Font Family", value: "fontFamily" },
        // { text: "Font Name", value: "fontName" },
        // { text: "Category", value: "categoryName" },
        // { text: "Type", value: "entityType" },
        { text: "has Profile", value: "hasProfile" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      editedItem: {
        name: "",
        latitude: "",
        longitude: "",
      },
      editedIndex: -1,
      defaultItem: {
        name: "",
        latitude: "",
        longitude: "",
      },
      //   pins: [
      //     {
      //       name: "Events",
      //       fontFamily: "MeterialDesignIcons",
      //       fontName: "",
      //       backgroundColor: "",
      //       fontColor: "",
      //     },
      //   ],
    };
  },
  computed: {
    ...mapState("$_entity", ["reviewedEntities"]),
    ...mapState("$_home", ["regions"]),
    modRegions() {
      var arr = [];
      arr.push({ id: "all", name: "All Entities" });
      arr = arr.concat(this.regions);
      return arr;
    },
  },
  created() {
    if (this.regions.length === 0) {
      this.getRegions({ collection: "regions", mutation: "updateRegions" });
    }
    if (this.reviewedEntities.length === 0) {
      this.getEntities({
        collection: "entities",
        condition: {
          leftVal: "state",
          operator: "==",
          rightVal: "reviewed",
        },
        mutation: "updateReviewedEntities",
      });
    }
  },
  methods: {
    ...mapActions({
      getEntities: "$_entity/getContent",
      getRegions: "$_home/getContent",
      getEntitiesByRegion: "$_entity/getEntitiesByRegion",
      deleteEntity: "$_entity/deleteContent",
    }),
    changeRegion() {
      if (this.selectedRegion.id === "all") {
        this.getEntities({
          collection: "entities",
          condition: {
            leftVal: "state",
            operator: "==",
            rightVal: "reviewed",
          },
          mutation: "updateReviewedEntities",
        });
      } else {
        this.getEntitiesByRegion(this.selectedRegion);
      }
    },
    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp.seconds * 1000;
        return moment(temp).format("lll");
      } else {
        return 0;
      }
    },
    openNewEntityDialog() {
      this.$refs.newEntityDialog.toggleDialog();
    },
    openEditProfileDialog(entity) {
      console.log(entity);
      // this.selectedEntity = entity;
      this.$refs.editProfileDialog.toggleDialog(entity);
    },
    openNewProfileDialog(entity) {
      this.$refs.newProfileDialog.toggleDialog(entity);
    },
    editItem(item) {
      this.editedIndex = this.reviewedEntities.indexOf(item);
      this.editedItem = Object.assign(
        {},
        this.reviewedEntities[this.editedIndex]
      );

      console.log("Edited Item: ", this.editedItem);

      this.$refs.editEntityDialog.toggleDialog(this.editedItem);
    },
    deleteItem(item) {
      this.editedIndex = this.reviewedEntities.indexOf(item);
      this.itemToDelete = Object.assign(
        {},
        this.reviewedEntities[this.editedIndex]
      );
      this.dialogDelete = true;

      console.log(item);
    },
    deleteItemConfirm() {
      this.deleteEntity({
        details: this.itemToDelete,
        collection: "entities",
        type: "Entity",
      }).then(() => {
        this.dialogDelete = false;
        this.getEntities({
          collection: "entities",
          condition: {
            leftVal: "state",
            operator: "==",
            rightVal: "reviewed",
          },
          mutation: "updateReviewedEntities",
        });
      });
    },
  },
};
</script>

<style>
</style>